import { gql } from '@apollo/client';
import RESOURCE_FRAGMENT from '../../fragments/resource';

const ADD_FAVORITE_RESOURCE = gql`
  mutation createFavorite($data: FavoriteCreateInput!) {
    createFavorite(data: $data) {
      id
      resourceId
      userId
      resource {
        ...BaseResource
      }
    }
  }
  ${RESOURCE_FRAGMENT}
`;

export default ADD_FAVORITE_RESOURCE;
